// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7":"aa246520","349":"7ffbe4c6"}[chunkId] + ".chunk.css";
};